<div
    class="fcp-accordion-item-header fcp-text-body-m"
    [ngClass]="{ 'fcp-accordion-item-disabled': disabled, 'fcp-accordion-item-open': isOpen }"
    (click)="!disabled && toggleOpen.emit()"
>
    <!-- TODO: Add chevron icon (beginning) -->
    {{ title }}
    <fcp-icon
        [ngClass]="{ 'fcp-accordion-open': isOpen }"
        class="fcp-accordion-icon"
        [icon]="'chevron-down'"
    ></fcp-icon>
</div>
<div class="fcp-accordion-item-content fcp-text-body-s" *ngIf="isOpen" [@openCloseAnimation]>
    <ng-content></ng-content>
</div>
